import React, { Component } from "react";
import { Field, FieldArray, reduxForm } from "redux-form";
import { injectIntl, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { Button, FormGroup, ControlLabel } from "react-bootstrap";
import cx from "classnames";

import s from "./ListPlaceStep1.css";
import bt from "../../components/commonStyle.css";
import messages from "../../locale/messages";
import SidePanel from "./SidePanel";

import InputField from "../Common/FormField/InputFieldComponent";
import FooterButton from "./FooterButton";
import update from "./update";
import InputFieldComponent from "../Common/FormField/InputFieldComponent";
import validate from "./validate";

class Page10 extends Component {
  renderFAQs = ({ fields, meta: { error, submitFailed } }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div>
        {fields?.map((faq, index) => (
          <div key={index} className={s.space3}>
            <FormGroup>
              <ControlLabel className={s.applyNewColor}>
                {formatMessage(messages.faqBlockTitle)} {index + 1}
              </ControlLabel>
              <Field
                name={`${faq}.title`}
                type="textarea"
                component={InputField}
                placeholder={formatMessage(messages.faqBlockTitle)}
                inputClass={cx(s.faqinputfield)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel className={s.applyNewColor}>
                {formatMessage(messages.faqBlockContent)} {index + 1}
              </ControlLabel>
              <Field
                name={`${faq}.content`}
                component={InputFieldComponent}
                componentClass={"textarea"}
                placeholder={formatMessage(messages.faqBlockContent)}
                inputClass={cx(s.faqTextarea)}
              />
            </FormGroup>
            {fields.length > 1 && (
              <Button
                className={cx(bt.btnPrimary, s.space2)}
                onClick={() => fields.remove(index)}
              >
                <FormattedMessage {...messages.remove} />
              </Button>
            )}
          </div>
        ))}
        <Button
          type="button"
          className={bt.btnPrimary}
          onClick={() => fields.push({})}
        >
          <FormattedMessage {...messages.addLabel} />
        </Button>
        {submitFailed && error && <span>{error}</span>}
      </div>
    );
  };

  render() {
    const { formatMessage } = this.props.intl;

    const { handleSubmit, previousPage, formPage, step, nextPage } = this.props;

    return (
      <div className={s.grid}>
        <SidePanel
          title={formatMessage(messages.stepOneCommonHeading)}
          landingContent={formatMessage(messages.faqheading)}
        />
        <form onSubmit={handleSubmit}>
          <div className={s.landingMainContent}>
            <ControlLabel className={cx(s.landingLabel, "textWhite")}>
              <FormattedMessage {...messages.faqForList} />
            </ControlLabel>
            <FieldArray name="faqs" component={this.renderFAQs} />
          </div>
          <FooterButton
            previousPage={previousPage}
            previousPagePath={"check-in-information"}
            formPage={formPage}
            step={step}
            // isDisabled={this.props.invalid}
            type={"submit"}
          />
        </form>
      </div>
    );
  }
}
const mapState = (state) => ({
  listingFields: state.listingFields.data,
});

Page10 = reduxForm({
  form: "ListPlaceStep1",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
  onSubmit: update,
})(Page10);

export default injectIntl(withStyles(s, bt)(connect(mapState)(Page10)));
